import * as React from 'react';
import { Card, CardBody, CardFooter, CardTitle, Button, Tooltip, GalleryItem } from '@patternfly/react-core';
import { SiteCheck } from '../../config/bootstrap';

interface CheckCardProps {
  check: SiteCheck;
  onStart: (check: SiteCheck) => void;
}

export const CheckCard: React.FunctionComponent<CheckCardProps> = ({ check, onStart }) => {
  const startButton = (
    <Button variant="primary" onClick={() => onStart(check)}>
      Start
    </Button>
  );

  return (
    <GalleryItem>
      <Card isFullHeight>
        <CardTitle>{check.title}</CardTitle>
        <CardBody>
          {check.body.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </CardBody>
        <CardFooter style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          {check.tooltip ? <Tooltip content={check.tooltip}>{startButton}</Tooltip> : startButton}
        </CardFooter>
      </Card>
    </GalleryItem>
  );
};
